import { all } from "redux-saga/effects";
import { getVppsWatcher } from "./getVpps.saga";
import { getVppsUsersWatcher } from "./getVppsUsers.saga";
import { getSubsidiariesWatcher } from "./getSubsidiaries.saga";
import { createVppWatcher, deleteVppWatcher } from "./saveVpp.saga";

export default function* rootSaga() {
    yield all([
        getVppsWatcher(),
        getVppsUsersWatcher(),
        getSubsidiariesWatcher(),
        createVppWatcher(),
        deleteVppWatcher()
    ]);
}
